// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.salary-specs-emp-list {
  display: flex;
  flex-direction: column;
}
.salary-specs-emp-list__head {
  display: flex;
}
.salary-specs-emp-list__head__nav {
  font-weight: 500;
  color: #868686;
}
.salary-specs-emp-list__head__nav-span {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #c1c1c1;
  padding-left: 10px;
  padding-right: 10px;
}
.salary-specs-emp-list__head__heading {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.salary-specs-emp-list__head__top {
  display: flex;
}
.salary-specs-emp-list__head__button {
  margin-bottom: -10px;
  margin-left: auto;
}
.salary-specs-emp-list__head__description {
  margin-top: 20px;
}
.salary-specs-emp-list__head__description__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #505054;
}
.salary-specs-emp-list__head__description__content {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.salary-specs-emp-list__body__reg-employee {
  margin-top: 18px;
  padding: 2%;
  background: #ffffff;
  border-radius: 16px;
}
.salary-specs-emp-list__body__reg-employee-2 {
  margin-top: 24px;
  padding: 2%;
  background: #ffffff;
  border-radius: 16px;
}
.salary-specs-emp-list__body__head {
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
}
.salary-specs-emp-list__body__head__heading {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: #333333;
}
.salary-specs-emp-list__body__head__number {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: #49ae9e;
  padding-left: 2px;
}
.salary-specs-emp-list__body__head__number-del {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: #e47c77;
  padding-left: 2px;
}
.salary-specs-emp-list__body__head__buttons {
  margin-left: auto;
  display: flex;
  align-items: center;
}
.salary-specs-emp-list__body__head__button {
  margin-left: 5px;
}
.salary-specs-emp-list__body__head__info {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  display: flex;
}
.salary-specs-emp-list__body__head__info__icon {
  padding-left: 10px;
}
.salary-specs-emp-list__body__head__dropdown {
  margin-top: 20px;
}
.salary-specs-emp-list__body__head__item {
  width: 180px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 8px 8px 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.salary-specs-emp-list__body__table-reg {
  width: 100%;
  border-collapse: collapse;
}
.salary-specs-emp-list__body__table-reg tr {
  cursor: pointer;
}
.salary-specs-emp-list__body__table-reg__td {
  border-bottom: 1px solid #e9e9e9;
  border-top: 1px solid #868686;
  text-align: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.salary-specs-emp-list__body__table-reg__td-center {
  text-align: center;
  border-bottom: 1px solid #e9e9e9;
  border-top: 1px solid #868686;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.salary-specs-emp-list__body__table-reg__td-content {
  border-bottom: 1px solid #e9e9e9;
  border-top: 1px solid #868686;
  text-align: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.salary-specs-emp-list__tooltip__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #505054;
}
.salary-specs-emp-list__tooltip__body {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #868686;
}
.salary-specs-emp-list__tooltip__highlight {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #E47C77;
}
.salary-specs-emp-list__clickable {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/screens/salary_specification/employee-list-for-payroll/employee-list-for-payroll.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;AACI;EACI,aAAA;AACR;AACQ;EACI,gBAAA;EACA,cAAA;AACZ;AAEQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAAZ;AAGQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADZ;AAIQ;EACI,aAAA;AAFZ;AAKQ;EACI,oBAAA;EACA,iBAAA;AAHZ;AAMQ;EACI,gBAAA;AAJZ;AAMY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAJhB;AAOY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AALhB;AAWQ;EACI,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AATZ;AAYQ;EACI,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AAVZ;AAaQ;EACI,aAAA;EACA,iBAAA;EACA,oBAAA;AAXZ;AAaY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAXhB;AAcY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAZhB;AAcY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAZhB;AAeY;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;AAbhB;AAgBY;EACI,gBAAA;AAdhB;AAiBY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AAfhB;AAiBgB;EACI,kBAAA;AAfpB;AAmBY;EACI,gBAAA;AAjBhB;AAoBY;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAnBhB;AAuBQ;EACI,WAAA;EACA,yBAAA;AArBZ;AAuBY;EACI,eAAA;AArBhB;AAwBY;EACI,gCAAA;EACA,6BAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtBhB;AAyBY;EACI,kBAAA;EACA,gCAAA;EACA,6BAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvBhB;AA0BY;EACI,gCAAA;EACA,6BAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxBhB;AA8BQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA5BZ;AA+BQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA7BZ;AAgCQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA9BZ;AAkCI;EACI,eAAA;AAhCR","sourcesContent":[".salary-specs-emp-list {\n    display: flex;\n    flex-direction: column;\n\n    &__head {\n        display: flex;\n        \n        &__nav {\n            font-weight: 500;\n            color: #868686;\n        }\n\n        &__nav-span {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #c1c1c1;\n            padding-left: 10px;\n            padding-right: 10px;\n        }\n\n        &__heading {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n        }\n\n        &__top {\n            display: flex;\n        }\n\n        &__button {\n            margin-bottom: -10px;\n            margin-left: auto;\n        }\n\n        &__description {\n            margin-top: 20px;\n\n            &__head {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 12px;\n                line-height: 18px;\n                color: #505054;\n            }\n\n            &__content {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 18px;\n                color: #999999;\n            }\n        }\n    }\n\n    &__body {\n        &__reg-employee {\n            margin-top: 18px;\n            padding: 2%;\n            background: #ffffff;\n            border-radius: 16px;\n        }\n\n        &__reg-employee-2 {\n            margin-top: 24px;\n            padding: 2%;\n            background: #ffffff;\n            border-radius: 16px;\n        }\n\n        &__head {\n            display: flex;\n            padding-top: 10px;\n            padding-bottom: 10px;\n\n            &__heading {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 22px;\n                line-height: 32px;\n                color: #333333;\n            }\n\n            &__number {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 22px;\n                line-height: 32px;\n                color: #49ae9e;\n                padding-left: 2px;\n            }\n            &__number-del {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 22px;\n                line-height: 32px;\n                color: #e47c77;\n                padding-left: 2px;\n            }\n\n            &__buttons {\n                margin-left: auto;\n                display: flex;\n                align-items: center;\n            }\n\n            &__button {\n                margin-left: 5px;\n            }\n\n            &__info {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #868686;\n                display: flex;\n\n                &__icon {\n                    padding-left: 10px;\n                }\n            }\n\n            &__dropdown {\n                margin-top: 20px;\n            }\n\n            &__item {\n                width: 180px;\n                height: 40px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px 8px 8px 8px;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n            }\n        }\n\n        &__table-reg {\n            width: 100%;\n            border-collapse: collapse;\n\n            tr {\n                cursor: pointer;\n            }\n\n            &__td {\n                border-bottom: 1px solid #e9e9e9;\n                border-top: 1px solid #868686;\n                text-align: center;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n\n            &__td-center {\n                text-align: center;\n                border-bottom: 1px solid #e9e9e9;\n                border-top: 1px solid #868686;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n\n            &__td-content {\n                border-bottom: 1px solid #e9e9e9;\n                border-top: 1px solid #868686;\n                text-align: center;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n        }\n    }\n\n    &__tooltip {\n        &__head {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 16px;\n            line-height: 22px;\n            color: #505054;\n        }\n\n        &__body {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 22px;\n            color: #868686;\n        }\n\n        &__highlight {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 22px;\n            color: #E47C77;\n        }\n    }\n\n    &__clickable {\n        cursor: pointer;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
